import React, { useEffect, useState } from 'react'
import { FaListUl, FaTasks } from 'react-icons/fa';
import axiosAuthInstance from '../../../../utils/axios/axiosAuthInstance'
import TaskCard from './TaskCard';

const TodayTaskReport = () => {
  const [tasksList, setTaskList] = useState([]);
  const [employees, setEmployees] = useState([])

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get('task/list', { sortPriority: true, limit: 30 })

      if (response && response.status === 200) {
        setTaskList(response.data?.result?.docs)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    fetchData()
    fetchTeamData()
  }, [])


  const fetchTeamData = async () => {
    try {
      const response = await axiosAuthInstance.get('team/dropdown')
      if (response && response?.status === 200) {
        setEmployees(response?.data?.result)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  return (
    <>
      <section>
        <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
          <FaTasks className="h-5 w-5" />
          Task Report
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <TaskCard tasksList={tasksList} />
        </div>
      </section>
      {/* <section>
        <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
          <FaListUl className="h-5 w-5" />
          Today Task Report
        </h2>
        <div className="bg-white rounded-lg shadow p-4">
          <p className="text-sm text-gray-600 mb-3">Employee List</p>
          <div className="flex flex-wrap gap-2">
            {employees?.length > 0 ? employees?.map((emp) => (
              <span
                key={emp._id}
                className="px-3 py-1 bg-orange-50 text-orange-500 rounded-full text-sm"
              >
                {emp.full_name}
              </span>
            )) : "No Employees"}
          </div>
        </div>
      </section> */}
    </>
  )
}

export default TodayTaskReport